import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { approveFollowerRequest, rejectFollowerRequest } from "../../../redux/actions/riderNetworkActions";
import { toast } from "react-toastify";

function FollowerRequestControl({
    user,
    subjectUser,
    approveFollowerRequest,
    rejectFollowerRequest
}) {

    useEffect(() => {
    }, [])

    function acceptRequest(e) {
        e.preventDefault();
        approveFollowerRequest(subjectUser, subjectUser.approveFollowers);
        toast.success(`Follow Request Accepted`);
    }

    function rejectRequest(e) {
        e.preventDefault();
        rejectFollowerRequest(subjectUser);
        toast.success(`Follow Request Rejected`);
    }

    return (
        <div className="profile-status-control">
            <button className="btn btn-sm btn-info" onClick={acceptRequest}>Accept</button>
            <button className="btn btn-sm btn-secondary" onClick={rejectRequest}>Reject</button>
        </div>
    );
};

FollowerRequestControl.propTypes = {
    user: PropTypes.object.isRequired,
    subjectUser: PropTypes.object.isRequired,
    approveFollowerRequest: PropTypes.func.isRequired,
    rejectFollowerRequest: PropTypes.func.isRequired
}

function mapStateToProps(state) {
    return {
        user: state.user
    };
}

const mapDispatchToProps = {
    approveFollowerRequest,
    rejectFollowerRequest
}

export default connect(mapStateToProps, mapDispatchToProps)(FollowerRequestControl);




// WEBPACK FOOTER //
// ./src/components/user/profile/FollowerRequestControl.js